import { CustomValuesOptionsQueryParams, CustomValuesQueryParams } from "PFCore/services/custom_values";

export const customValuesKeys = {
  all: () => ["customValues"],
  list: (params: CustomValuesQueryParams) => [...customValuesKeys.all(), params],
  options: (params: CustomValuesOptionsQueryParams) => [...customValuesKeys.all(), params]
};
